import { render, staticRenderFns } from "./TypeEffect.vue?vue&type=template&id=96919846&scoped=true&"
import script from "./TypeEffect.vue?vue&type=script&lang=js&"
export * from "./TypeEffect.vue?vue&type=script&lang=js&"
import style0 from "./TypeEffect.vue?vue&type=style&index=0&id=96919846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96919846",
  null
  
)

export default component.exports